/**
 * Scroll a component into view (if applicable)
 * */
export const scrollToField = (className?: string) => {
  const element = className ? document.querySelector(className) : ''
  if (element)
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
}

/**
 * Allows scrolling to an element with a specific offset
 */
export const scrollToElement = (
  elementSelector: string,
  parentSelector: string,
  yOffset: number = 0
) => {
  const element = document.querySelector(elementSelector)
  const body = document.querySelector(parentSelector)
  if (element && body) {
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
    body.scrollTo({ top: y, behavior: 'smooth' })
  }
}
